import { Button, Icon, Modal, Text } from '@msc-b2c/shared-components';
import React from 'react';
import { ApiErrorModalProps } from '@msc-b2c/interfaces/types';
import './errormodal.module.scss';

export const ErrorModal = ({
  title,
  message,
  styleOption = '',
  iconType,
  closingIcon,
  ctaLabel,
  ctaLink,
  handleClosure,
  handleClick,
}: Readonly<ApiErrorModalProps>) => {
  const closeIconName = closingIcon || '';

  return (
    <div className={'cmp-error-modal'}>
      <div className={'overlay'}></div>
      <Modal
        styleOption={styleOption}
        modalIcon={closeIconName}
        hideCloseIcon={true}
        onClose={handleClosure}
      >
        <div className="modal-header">
          {iconType && (
            <Icon
              styleOption={'modal-header__icon'}
              icon={iconType}
            />
          )}
          <Text
            styleOption="modal-error-title"
            text={title}
          ></Text>
          {handleClosure && (
            <Icon
              styleOption={'modal-header__close-icon'}
              icon={closeIconName}
              onClick={handleClosure}
            />
          )}
        </div>
        <div className="modal-error">
          <Text
            text={message}
            tagHtml="div"
          ></Text>
        </div>
        {(ctaLink || handleClick) && (
          <div className="button-wrapper">
            {ctaLink && (
              <Button
                text={ctaLabel}
                buttonLink={ctaLink}
              />
            )}
            {handleClick && (
              <Button
                text={ctaLabel}
                onClick={handleClick}
                styleOption={'cmp-button__primary  -button-position-right'}
              />
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};
